import { render } from "./AgencyDetailsComponent.vue?vue&type=template&id=0aed4ab8&scoped=true&ts=true"
import script from "./AgencyDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./AgencyDetailsComponent.vue?vue&type=script&lang=ts"

import "./AgencyDetailsComponent.vue?vue&type=style&index=0&id=0aed4ab8&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aed4ab8"]])

export default __exports__